<template lang="pug">
div.body-reg
  div.modal-header
    span.reg-modal-title ĐĂNG KÝ TÀI KHOẢN MỚI
    span.reg-modal-btn-close.material-icons(@click="exitRegister") close
  div.modal-body
    p.reg-content Bạn muốn đăng ký tài khoản với vai trò nào?
    div.row
      div.col-md-6.col-12.text-center.reg-select-student
        div.border-box
          div(:class="selectStudent ? 'item-type-selected' : 'item-unselect'", @click="itemSelect('student')")
            img(src="../../assets/images/register/img_student.svg")
            p.reg-body-title Học sinh
      div.col-md-6.col-12.text-center.reg-select-teacher
        div.border-box
          div(:class="selectTeacher ? 'item-type-selected' : 'item-unselect'", @click="itemSelect('teacher')")
            img(src="../../assets/images/register/img_teacher.svg")
            p.reg-body-title Giáo viên
  div.modal-footer.reg-custom-footer
    div.row
      div.col-md-6.col-xs-6.col-12
        div.text-right
          button.reg-btn-continue.btn(@click='validateRegister()') Tiếp tục
      div.col-md-6.col-xs-6.col-12
        div.text-left
          button.reg-btn-back.btn(@click="exitRegister") Quay lại
</template>

<script>
import store from '../../store'
export default {
  components: {},
  props: {
    selectedTeacher: Boolean,
    selectedStudent: Boolean,
    newEmail: String,
    newFullName: String,
    newPicture: String,
    newName: String,
    newFrontTop: Number,
    currentPage: Number
  },
  data() {
    return {
      selectTeacher: this.selectedTeacher,
      selectStudent: true,
      name: this.newName,
      front_top: this.newFrontTop,
      page: this.currentPage
    }
  },
  methods: {
    itemSelect(params) {
      if (params === 'student') {
        this.selectStudent = true
        this.selectTeacher = false
      } else {
        this.selectStudent = false
        this.selectTeacher = true
      }
    },
    validateRegister() {
      if (this.selectStudent === true && this.selectTeacher === false) {
        this.$emit('close')
        if (this.newEmail && this.newFullName) {
          this.$router.push({name: 'Register Student', params: {newEmail: this.newEmail, newFullName: this.newFullName, newPicture: this.newPicture, name: this.name, front_top: this.front_top, currentPage: this.page}})
        } else {
          store.commit('setIsHomePage', false)
          this.$router.push({name: 'Register Student', params: {name: this.name, front_top: this.front_top, currentPage: this.page}})
        }
      } else if (this.selectStudent === false && this.selectTeacher === true) {
        this.$emit('close')
        if (this.newEmail && this.newFullName) {
          this.$router.push({name: 'Register Teacher', params: {newEmail: this.newEmail, newFullName: this.newFullName, newPicture: this.newPicture, name: this.name, front_top: this.front_top, currentPage: this.page}})
        } else {
          store.commit('setIsHomePage', false)
          this.$router.push({name: 'Register Teacher', params: {name: this.name, front_top: this.front_top, currentPage: this.page}})
        }
      }
    },
    exitRegister() {
      this.$store.dispatch('signOutAction')
      this.$emit('close')
    }
  },
  created() {
    store.commit('setIsLoggedIn', false)
    if (this.$route.params.front_top !== undefined) {
      this.name = this.$route.params.name
      this.front_top = this.$route.params.front_top
      this.page = this.$route.params.currentPage
    }
  }
}
</script>
<style lang="scss">
:root {
  // Color 
  --color-type-selected: #9F6A28;
  --color-background-button: #FFD311;
}
.item-type-selected {
  box-shadow: 0px 1px 2px #00000029;
  border-radius: 5px;
  border: 3px solid var(--color-type-selected);
}
.item-type-selected::after,
.item-type-selected::before {
  border: 3px solid var(--color-type-selected);
  border: 3px solid var(--color-type-selected);
}

.item-unselect {
  border: 3px solid transparent;
  box-shadow: 0px 1px 2px #00000029;
  border-radius: 5px;
  opacity: 1;
}

.body-reg {
  margin-left: 20px;
  margin-right: 20px;
  background-color: white;
  box-shadow: 0px 3px 6px #00000029;
  border-radius: 10px;
  font-family: 'adobe-clean', sans-serif;
  .reg-modal-title {
    // font-weight: bold;
    float: left;
    font-size: 17px;
  }
  .reg-modal-btn-close {
    float: right;
    &:hover {
      cursor: pointer;
    }
  }
  .reg-body-title {
    color: var(--color-type-selected);
    margin-bottom: 0;
    padding-bottom: 3px;
  }
  .reg-content {
    margin-bottom: 15px;
    font-size: 15px;
  }
  // .reg-select-student{}
  .reg-select-teacher{
    padding-left: 0
  }
  
  .reg-btn-continue {
    background: var(--color-background-button);
    color:black;
    text-transform: none;
    font-size: 13px;
    border: 1px solid #FFD311;
    border-radius: 5px;
    // box-shadow: 0px 0px 0px;
    width: 160px;
    margin-top: 0 !important;
    margin-bottom: 15px;
  }
  .reg-btn-back {
    background: white;
    color: black;
    text-transform: none;
    font-size: 13px;
    border: 1px solid #FFD311;
    border-radius: 5px;
    // box-shadow: 0px 0px 0px;
    width: 160px;
    margin-top: 0 !important;
  }
  .reg-custom-footer {
    padding: 0;
    border: 0;
  }
@media (max-width: 991px) {
  .border-box {margin-bottom: 10px}
  .reg-select-student{width: 100%;
    .border-box{margin-bottom: 10px;}
  }
  .reg-select-teacher{width: 100%; padding-left: 15px;}
}
@media (max-width: 767px) {
  .border-box {margin-bottom: 10px}
  .reg-select-student{width: 100%;
    .border-box{margin-bottom: 10px;}
  }
  .reg-select-teacher{width: 100%; padding-left: 15px;}
}
// cellphones 
@media (max-width: 414px) {
  .border-box {
    margin-left: 25px;
    margin-right: 20px;
    margin-bottom:10px;
    box-shadow: 0px 1px 2px #00000029;
    border-radius: 5px;
  }
  .reg-select-teacher{
    padding-left: 15px;
  }

  .reg-btn-continue {
    float: left;
    margin-left: 40px;
    width: 115px;
  }
  .reg-btn-back {
    float: right;
    margin-right: 35px;
    width: 115px;
  }
}
@media (max-width: 320px) {
  .reg-custom-footer{
    .col-xs-6{
      .reg-btn-back{margin-right:15px;}
      .reg-btn-continue{margin-left: 15px;}
    }
  }
}

}
</style>



// WEBPACK FOOTER //
// RegisterModal.vue?0b029945